import { render, staticRenderFns } from "./Chatbot.vue?vue&type=template&id=f21be254&"
import script from "./Chatbot.vue?vue&type=script&lang=js&"
export * from "./Chatbot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports